'use client';

import { Dialog, DialogContent } from '@skin-seoul/design-system';

import { SkinSocietyBenefits } from '../SkinSocietyBenefits';

interface SkinSocietyBenefitsModalProps {
  isOpen: boolean;
  onClose: () => void;
  showBottomNav?: boolean;
  showSigninComment?: boolean;
}

export const SkinSocietyBenefitsModal = ({
  isOpen,
  onClose,
  showBottomNav = true,
  showSigninComment = false,
}: SkinSocietyBenefitsModalProps) => {
  const bottomMargin = showBottomNav ? '63px' : '0px';
  const maxContentHeight = showSigninComment ? '95dvh' : '80dvh';
  const maxBodyHeight = showBottomNav ? `calc(${maxContentHeight} - 63px)` : maxContentHeight;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        showCloseButton={false}
        className="w-full max-w-[100vw] bg-transparent rounded-t-[20px] rounded-b-none mx-0 my-0 overflow-hidden p-0 fixed bottom-0 left-0 right-0 top-auto translate-x-0 translate-y-0"
        style={{ maxHeight: maxContentHeight, marginBottom: bottomMargin }}
      >
        <div
          className="p-4 pt-[132px] relative z-[1] overflow-auto bg-primary-900"
          style={{ maxHeight: maxBodyHeight }}
        >
          <SkinSocietyBenefits showSigninComment={showSigninComment} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
